import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { BehaviorSubject, share } from 'rxjs';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileDataType } from '../../../file-input/file-data.helper';

export interface PreviewModalData {
  fileType: FileDataType;
  file: File | null;
}

@Component({
  selector: 'ui-preview-modal',
  templateUrl: './preview-modal.component.html',
  styleUrls: ['./preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewModalComponent implements OnInit {
  private _url = new BehaviorSubject('');

  public resourceUrl$ = this._url.asObservable().pipe(share());
  public previewModalDataType = FileDataType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PreviewModalData,
    private _dialogRef: MatDialogRef<PreviewModalComponent>,
  ) {}

  public ngOnInit(): void {
    if (this.data.file) {
      const reader = new FileReader();
      reader.onload = () => {
        const url = reader.result as string;
        this._url.next(url);
      };
      reader.readAsDataURL(this.data.file);
    }
  }

  public closeModal(event: Event): void {
    if (event instanceof KeyboardEvent && event.key !== 'Enter') {
      return;
    }

    event.preventDefault();

    this._dialogRef.close();
  }
}
